if (!customElements.get('video-showcase')) {
    customElements.define(
        'video-showcase',
        class VideoShowcase extends HTMLElement {
            constructor() {
                super();

                this.scrollTop = 0;
                this.number = 0;
                this.mySwiper = null;
                this.mainSwiper = null;

                this.productDialog =
                    this.nextElementSibling && this.nextElementSibling.matches('.product_dialog')
                        ? this.nextElementSibling
                        : null;
                this.mainSwiperEl = this.querySelector('.user-showcase-container');
                this.swiperEl = this.productDialog ? this.productDialog.querySelector('.swiper_product') : null;
                this.closeDialogButton = this.productDialog ? this.productDialog.querySelector('.close_dialog') : null;
                this.showMoreButton = this.querySelector('.showcase_image_wall .show_more');
                this.imageItems = this.querySelectorAll('.image_list .image_item');
                this.userShowcaseItems = this.querySelectorAll('.image_list .image_item .user-showcase-item');
                this.swiperButtonPrev = this.swiperEl ? this.swiperEl.querySelectorAll('.button_prev') : [];
                this.swiperButtonNext = this.swiperEl ? this.swiperEl.querySelectorAll('.button_next') : [];

                this.handleProductClick = this.handleProductClick.bind(this);
                this.handleCloseDialog = this.handleCloseDialog.bind(this);
                this.handleShowMore = this.handleShowMore.bind(this);
            }

            connectedCallback() {
                this.initMainSwiper();
                this.initSwiper();

                this.userShowcaseItems.forEach(item => item.addEventListener('click', this.handleProductClick));

                if (this.closeDialogButton) {
                    this.closeDialogButton.addEventListener('click', this.handleCloseDialog);
                }

                if (this.showMoreButton) {
                    this.number = parseInt(this.showMoreButton.dataset.only);
                    this.showMoreButton.addEventListener('click', this.handleShowMore);
                }
            }

            disconnectedCallback() {
                if (this.mySwiper) this.mySwiper.destroy();
                if (this.mainSwiper) this.mainSwiper.destroy();

                this.userShowcaseItems.forEach(item => item.removeEventListener('click', this.handleProductClick));
                if (this.closeDialogButton) this.closeDialogButton.removeEventListener('click', this.handleCloseDialog);
                if (this.showMoreButton) this.showMoreButton.removeEventListener('click', this.handleShowMore);
            }

            pauseAllVideos() {
                this.imageItems.forEach((item, index) => {
                    const videoEl = this.swiperEl.querySelector(`#video-${index + 1}`);
                    if (videoEl) {
                        try {
                            videoEl.pause();
                        } catch (error) {
                        }
                    }
                });
            }

            updateButtonState(swiper) {
                if (!swiper) return;
                const isBeginning = swiper.activeIndex === 0;
                const isEnd = swiper.activeIndex === swiper.slides.length - 1;

                this.swiperButtonPrev.forEach(btn =>
                    btn.classList.toggle('swiper-button-disabled', isBeginning)
                );
                this.swiperButtonNext.forEach(btn =>
                    btn.classList.toggle('swiper-button-disabled', isEnd)
                );
            }

            initMainSwiper() {
                if (!this.mainSwiperEl) {
                    return;
                }

                const prev = this.querySelector('.image_list .swiper-button-prev');
                const next = this.querySelector('.image_list .swiper-button-next');

                this.mainSwiper = new Swiper(this.mainSwiperEl, {
                    slidesPerView: 3.5,
                    spaceBetween: 24,
                    navigation: { nextEl: next, prevEl: prev },
                    breakpoints: {
                        320: { slidesPerView: 2.2, spaceBetween: 8 },
                        450: { slidesPerView: 2, spaceBetween: 24 },
                        769: { slidesPerView: 2.5, spaceBetween: 24 },
                        1001: { slidesPerView: 3, spaceBetween: 24 },
                    },
                    on: {
                        init: swiper => {
                            setTimeout(() => {
                                swiper.slideTo(1);
                                swiper.slideTo(0);
                            }, 500);
                        },
                    },
                });
            }

            initSwiper() {
                if (!this.swiperEl) {
                    return;
                }

                const firstSlide = this.swiperEl.querySelector('.swiper-wrapper .product_item');
                if (firstSlide) firstSlide.style.display = 'flex';

                this.swiperButtonPrev = Array.from(this.swiperEl.querySelectorAll('.button_prev'));
                this.swiperButtonNext = Array.from(this.swiperEl.querySelectorAll('.button_next'));

                this.mySwiper = new Swiper(this.swiperEl, {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    effect: 'fade',
                    autoHeight: true,
                    fadeEffect: { crossFade: true },
                    observer: true,
                    observeParents: true,
                    on: {
                        init: swiper => {
                            this.updateButtonState(swiper);

                            this.swiperButtonPrev.forEach(btn => {
                                btn.addEventListener('click', () => {
                                    if (swiper.activeIndex > 0) swiper.slidePrev();
                                    this.updateButtonState(swiper);
                                });
                            });

                            this.swiperButtonNext.forEach(btn => {
                                btn.addEventListener('click', () => {
                                    if (swiper.activeIndex < swiper.slides.length - 1) swiper.slideNext();
                                    this.updateButtonState(swiper);
                                });
                            });

                            swiper.on('slideChange', () => this.updateButtonState(swiper));
                        },

                        slideChangeTransitionEnd: swiper => {
                            this.pauseAllVideos();
                            try {
                                const activeIndex = swiper.activeIndex;
                                const videoEl = this.swiperEl.querySelector(`#video-${activeIndex + 1}`);
                                if (videoEl) {
                                    videoEl.play();
                                }
                            } catch (error) {
                            }
                        },
                    },
                });
            }

            handleProductClick(event) {
                const index = parseInt(event.currentTarget.getAttribute('index'));
                const num = index - 1;

                const slides = this.swiperEl.querySelectorAll('.swiper-wrapper .product_item');
                if (num >= slides.length) {
                    return;
                }

                this.mySwiper.slideTo(num, 0);
                setTimeout(() => {
                    this.updateButtonState(this.mySwiper);
                }, 100);

                if (this.productDialog) {
                    this.productDialog.style.display = 'block';
                }

                document.body.classList.add('noscroll');

                const videoEl = this.swiperEl.querySelector(`#video-${index}`);
                if (videoEl) {
                    videoEl.play();
                }
            }

            handleCloseDialog() {
                this.pauseAllVideos();
                if (this.productDialog) {
                    this.productDialog.style.display = 'none';
                }
                document.body.classList.remove('noscroll');
            }

            handleShowMore() {
                const addCount = parseInt(this.showMoreButton.dataset.only);
                this.number += addCount;

                const slides = this.swiperEl.querySelectorAll('.swiper-wrapper .product_item');
                for (let i = 0; i < Math.min(this.number, slides.length); i++) {
                    if (this.imageItems[i]) this.imageItems[i].style.display = 'block';
                    if (slides[i]) slides[i].style.display = 'flex';
                }

                this.mySwiper.update(true);

                if (
                    this.imageItems.length > 0 &&
                    getComputedStyle(this.imageItems[this.imageItems.length - 1]).display === 'block'
                ) {
                    this.showMoreButton.style.display = 'none';
                }
            }
        }
    );
}
